<app-state-section [state]="sectionState" [errorStateLabel]="'ErrorMessages.ErrorHappened' | translate">
  <form class="form-group flex column filter-form" [formGroup]="form" *ngIf="form">
    <div class="field flex column">
      <mat-label class="field-label">{{ "Filter.Form.Time" | translate }}</mat-label>
      <div class="dropdown-field">
        <app-date-range
        formControlName="dateRange"
        [showCustomDateOption]="true"
      ></app-date-range>
      </div>
    </div>

    <div class="field flex column">
      <mat-label class="field-label">{{ "Filter.Form.Customer" | translate }}</mat-label>
      <div class="dropdown-field w-100">
        <app-lazy-dropdown
        formControlName="customerId"
        [lookup]="LookupType.Customers"
       >
      </app-lazy-dropdown>
      </div>
    </div>

  </form>
</app-state-section>
